import React from 'react';
import { Select } from 'components';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const Freebox = {
  orgId: '9729bfe7-8e90-459c-b7bb-db68c52c5fe8',
  panelId: '5d088fe3-f224-4950-8e25-c18dfd9edf3d',
  specialFields: [
    {
      name: '__freeboxBox',
      participantLabel: 'Box internet',
      clientLabel: 'Box',
      formComponent: (props: { name: string; label: string }) => (
        <Select
          options={['Freebox Pop', 'Freebox Révolution', 'Freebox Delta']}
          {...props}
        />
      ),
    },
  ],
};
